<template>
    <Breadcrumbs main="Widgets" title="Apps Page" />
    <div class="container-fluid">

        <orderChart />

    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

const orderChart = defineAsyncComponent(() => import("@/components/pages/apps/index.vue"))
</script>